/**
 * Toggle «Acreditar sobrante a saldo a favor» del diálogo NC / NC-X.
 * Habilitado solo si la factura no es la cuenta Consumidor Final.
 *
 * Misma identidad que el alta: flag `esConsumidorFinal` o cliente codigo CF.
 * El nombre y la condición IVA no alcanzan.
 */

export const NC_SALDO_CF_COPY =
  "Apagado y disabled. No se puede dejar el importe en la cuenta CF";

export type NcSaldoFactura = {
  esConsumidorFinal?: boolean;
  es_consumidor_final?: boolean;
  cliente?: { codigo?: string | null } | null;
};

export function ncSaldoToggleEnabled(
  factura: NcSaldoFactura | null | undefined,
): boolean {
  if (!factura) return true;
  if (factura.esConsumidorFinal === true || factura.es_consumidor_final === true) {
    return false;
  }
  const cliente = factura.cliente;
  if (!cliente || typeof cliente !== "object") return true;
  return String(cliente.codigo ?? "").trim().toUpperCase() !== "CF";
}
